module.exports = __webpack_public_path__ + "static/media/gpv-opening-hours.98c51ef6.jpg";